import { token } from '@/infrastructure/container';
import { type LocaleCode } from '@/i18n/messages';

export interface IBrowserLocale {
  preferredFrom(supported: readonly LocaleCode[]): LocaleCode;
}

export const TOKEN_IBrowserLocale = token<IBrowserLocale>('IBrowserLocale');

export class BrowserLocale implements IBrowserLocale {
  preferredFrom(supported: readonly LocaleCode[]): LocaleCode {
    const tags = (navigator.languages?.length ? navigator.languages : [navigator.language]) ?? [];
    for (const tag of tags) {
      const base = tag.toLowerCase().split('-')[0];
      const hit = supported.find((s) => s === base);
      if (hit) return hit;
    }
    return supported[0];
  }
}

export class InMemoryBrowserLocale implements IBrowserLocale {
  constructor(private forced: LocaleCode) {}
  preferredFrom(supported: readonly LocaleCode[]): LocaleCode {
    return supported.includes(this.forced) ? this.forced : supported[0];
  }
}
